/**
 * Lithofinder AI Chat Widget v2
 *
 * Tier 1 - Client-side FAQ matching (0 API cost, instant)
 *   Uses window.LithofinFAQ (152+ FAQs with multilingual keywords)
 * Tier 2 - Server-side AI via Shopify App Proxy → Cloudflare Worker
 *   Product guides, stone encyclopedia, recipes, schedules, GPT-4o-mini
 *
 * FAQ data loaded via faq-data.js (auto-generated by build-knowledge-bundle.ts)
 */
(function () {
  "use strict";

  const root = document.getElementById("lithofinder-chat");
  if (!root) return;

  const proxyUrl = root.dataset.proxyUrl || "/apps/lithofinder";
  const locale = document.getElementById("lf-chat-locale")?.dataset || {};
  const lang = (document.documentElement.lang || "en").substring(0, 2).toLowerCase();
  const rootUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/").replace(/\/$/, "");

  // Elements
  const toggle = root.querySelector(".lf-chat__toggle");
  const window_ = root.querySelector(".lf-chat__window");
  const closeBtn = root.querySelector(".lf-chat__close");
  const messagesEl = root.querySelector(".lf-chat__messages");
  const input = root.querySelector(".lf-chat__input");
  const sendBtn = root.querySelector(".lf-chat__send");
  const iconChat = root.querySelector(".lf-chat__icon-chat");
  const iconClose = root.querySelector(".lf-chat__icon-close");

  let isOpen = false;
  let isLoading = false;
  let history = [];
  let faqLoaded = false;

  // ── Client-side FAQ Matching ───────────────────────────────────
  function matchFAQLocally(question) {
    var faqs = window.LithofinFAQ;
    if (!faqs || !faqs.length) return null;

    var q = question.toLowerCase();
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < faqs.length; i++) {
      var faq = faqs[i];
      var score = 0;
      var kw = faq.kw || {};

      // Score keywords per language, boost current language
      for (var kwLang in kw) {
        var keywords = kw[kwLang];
        if (!keywords) continue;
        for (var j = 0; j < keywords.length; j++) {
          if (q.indexOf(keywords[j].toLowerCase()) >= 0) {
            score += (kwLang === lang) ? 3 : 1;
          }
        }
      }

      if (score > bestScore) {
        bestScore = score;
        best = faq;
      }
    }

    // Require minimum score of 2 for a match
    return bestScore >= 2 ? best : null;
  }

  // ── Toggle Chat ────────────────────────────────────────────────
  function loadFAQData() {
    if (faqLoaded) return;
    faqLoaded = true;
    var faqUrl = root.dataset.faqUrl;
    if (faqUrl) {
      var s = document.createElement("script");
      s.src = faqUrl;
      document.head.appendChild(s);
    }
  }

  function openChat() {
    isOpen = true;
    loadFAQData();
    window_.style.display = "flex";
    iconChat.style.display = "none";
    iconClose.style.display = "block";
    toggle.classList.add("lf-chat__toggle--active");
    input.focus();
  }

  function closeChat() {
    isOpen = false;
    window_.style.display = "none";
    iconChat.style.display = "block";
    iconClose.style.display = "none";
    toggle.classList.remove("lf-chat__toggle--active");
  }

  toggle.addEventListener("click", function () {
    isOpen ? closeChat() : openChat();
  });

  closeBtn.addEventListener("click", closeChat);

  // ── Auto-resize textarea ───────────────────────────────────────
  input.addEventListener("input", function () {
    this.style.height = "auto";
    this.style.height = Math.min(this.scrollHeight, 120) + "px";
  });

  // ── Send on Enter (Shift+Enter for newline) ───────────────────
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  sendBtn.addEventListener("click", sendMessage);

  // ── Quick-link buttons ─────────────────────────────────────────
  root.querySelectorAll(".lf-chat__quick").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var q = btn.dataset.q;
      if (q) {
        input.value = q;
        sendMessage();
        // Hide quick links after first use
        var quickWrap = root.querySelector(".lf-chat__quick-links");
        if (quickWrap) quickWrap.style.display = "none";
      }
    });
  });

  // ── Add Message to UI ──────────────────────────────────────────
  function addMessage(text, sender, products, knowledgeLinks) {
    var msg = document.createElement("div");
    msg.className = "lf-chat__msg lf-chat__msg--" + sender;

    var bubble = document.createElement("div");
    bubble.className = "lf-chat__bubble";
    bubble.innerHTML = formatMessage(text);
    msg.appendChild(bubble);

    // Add product links if available - use Liquid-generated URL map for correct multi-language URLs
    if (products && products.length > 0) {
      var productsEl = document.createElement("div");
      productsEl.className = "lf-chat__products";
      var idMap = (window.LithofinderData && window.LithofinderData.productIdMap) || {};
      var articleMap = (window.LithofinderData && window.LithofinderData.productMap) || {};
      var urlMap = window.LithofinProductUrls || {};
      products.forEach(function (product) {
        var article = articleMap[product] || "";
        var shopifyId = idMap[article] || "";
        var href = (shopifyId && urlMap[shopifyId]) ? urlMap[shopifyId] : rootUrl + "/collections/all";
        var link = document.createElement("a");
        link.href = href;
        link.className = "lf-chat__product-link";
        link.textContent = product;
        link.target = "_self";
        productsEl.appendChild(link);
      });
      msg.appendChild(productsEl);
    }

    // Add knowledge page links (stone/problem guides)
    if (knowledgeLinks && knowledgeLinks.length > 0) {
      var knEl = document.createElement("div");
      knEl.className = "lf-chat__knowledge";
      knowledgeLinks.forEach(function (kl) {
        var a = document.createElement("a");
        a.href = kl.url;
        a.className = "lf-chat__knowledge-link lf-chat__knowledge-link--" + kl.type;
        a.textContent = kl.label;
        knEl.appendChild(a);
      });
      msg.appendChild(knEl);
    }

    messagesEl.appendChild(msg);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return bubble;
  }

  function addErrorWithRetry(lastText) {
    var msg = document.createElement("div");
    msg.className = "lf-chat__msg lf-chat__msg--bot";

    var bubble = document.createElement("div");
    bubble.className = "lf-chat__bubble";
    bubble.textContent = locale.error || "Sorry, something went wrong.";

    var retryBtn = document.createElement("button");
    retryBtn.className = "lf-chat__retry";
    retryBtn.textContent = locale.retry || "Try again";
    retryBtn.style.cssText = "display:block;margin-top:8px;padding:4px 12px;border:1px solid currentColor;border-radius:12px;background:none;color:inherit;cursor:pointer;font-size:0.85em;";
    retryBtn.addEventListener("click", function () {
      msg.remove();
      // Remove the failed user message from history
      if (history.length > 0 && history[history.length - 1].role === "user") {
        history.pop();
      }
      handleSend(lastText);
    });

    bubble.appendChild(retryBtn);
    msg.appendChild(bubble);
    messagesEl.appendChild(msg);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function addThinking() {
    var msg = document.createElement("div");
    msg.className = "lf-chat__msg lf-chat__msg--bot lf-chat__msg--thinking";

    var bubble = document.createElement("div");
    bubble.className = "lf-chat__bubble";
    bubble.innerHTML =
      '<span class="lf-chat__dots"><span></span><span></span><span></span></span>';
    msg.appendChild(bubble);

    messagesEl.appendChild(msg);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return msg;
  }

  function removeThinking() {
    var thinking = messagesEl.querySelector(".lf-chat__msg--thinking");
    if (thinking) thinking.remove();
  }

  // ── Format message text (basic markdown) ───────────────────────
  function formatMessage(text) {
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
      .replace(/\*(.*?)\*/g, "<em>$1</em>")
      .replace(/`([^`]+)`/g, "<code>$1</code>")
      .replace(/^- (.+)/gm, "• $1")
      .replace(/\n/g, "<br>");
  }

  // ── Send Message ───────────────────────────────────────────────
  function sendMessage() {
    var text = input.value.trim();
    if (!text || isLoading) return;
    input.value = "";
    input.style.height = "auto";
    handleSend(text);
  }

  async function handleSend(text) {
    if (!text || isLoading) return;

    // Add user message
    addMessage(text, "user");
    history.push({ role: "user", content: text });

    // ── Tier 1: Client-side FAQ match (every message) ──
    var faqMatch = matchFAQLocally(text);
    if (faqMatch) {
        var answer = faqMatch.a;
        var products = faqMatch.products || [];
        var knLinks = [];
        (faqMatch.stones || []).forEach(function (s) {
          var label = s.replace(/-/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); });
          knLinks.push({ type: "stone", url: rootUrl + "/pages/stone-" + s, label: label });
        });
        (faqMatch.problems || []).forEach(function (p) {
          var label = p.replace(/-/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); });
          knLinks.push({ type: "problem", url: rootUrl + "/pages/problem-" + p, label: label });
        });
        addMessage(answer, "bot", products, knLinks);
        history.push({ role: "assistant", content: answer });
        return;
    }

    // ── Tier 2+: Server-side (Worker → product guide / stone / GPT) ──
    isLoading = true;
    sendBtn.disabled = true;
    var thinkingMsg = addThinking();
    var thinkStart = Date.now();

    try {
      // Read camera scan context if available (expires after 10 min)
      var scanCtx = null;
      var ls = window.__lithofinLastScan;
      if (ls && (Date.now() - ls.timestamp) < 600000) scanCtx = ls;

      var response = await fetch(proxyUrl + "/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: text,
          history: history.slice(-10),
          language: lang,
          scan_context: scanCtx,
        }),
      });

      // Ensure thinking dots show for at least 400ms
      var elapsed = Date.now() - thinkStart;
      if (elapsed < 400) {
        await new Promise(function (r) { setTimeout(r, 400 - elapsed); });
      }

      removeThinking();

      if (response.status === 429) {
        addMessage(locale.rateLimit || "Too many requests. Please try again later.", "bot");
        return;
      }

      if (!response.ok) {
        addErrorWithRetry(text);
        return;
      }

      var data = await response.json();
      var answer = data.answer || "";
      var products = data.products || [];

      addMessage(answer, "bot", products);
      history.push({ role: "assistant", content: answer });

      // Keep history manageable
      if (history.length > 20) {
        history = history.slice(-20);
      }
    } catch (err) {
      removeThinking();
      addErrorWithRetry(text);
      console.error("Chat error:", err);
    } finally {
      isLoading = false;
      sendBtn.disabled = false;
      input.focus();
    }
  }
})();

